if (!customElements.get('luvilia-delivery-details')) {
  customElements.define('luvilia-delivery-details', class extends HTMLElement {
    connectedCallback() {
      this.link = this.querySelector('a');
      const href = this.link?.getAttribute('href') || '';
      this.target = href.startsWith('#') ? document.getElementById(href.slice(1)) : null;
      if (!this.target || this.target.tagName !== 'DETAILS') return;
      this.onClick = (event) => {
        if (event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        const disclosure = this.target.closest('accordion-disclosure');
        if (disclosure && typeof disclosure.open === 'function') {
          disclosure.open({ instant: true });
        } else {
          this.target.open = true;
          this.target.setAttribute('aria-expanded', 'true');
        }
        const summary = this.target.querySelector('summary');
        summary?.focus({ preventScroll: true });
        summary?.scrollIntoView({ block: 'start', behavior: 'auto' });
        this.syncExpanded();
      };
      this.observer = new MutationObserver(() => this.syncExpanded());
      this.observer.observe(this.target, { attributes: true, attributeFilter: ['open', 'aria-expanded'] });
      this.link.addEventListener('click', this.onClick);
      this.syncExpanded();
    }

    disconnectedCallback() {
      this.link?.removeEventListener('click', this.onClick);
      this.observer?.disconnect();
    }

    syncExpanded() {
      const expanded = this.target.open && this.target.getAttribute('aria-expanded') !== 'false';
      this.link.setAttribute('aria-expanded', String(expanded));
    }
  });
}
